import {
  Activity,
  BankCard,
  HeadsetOne,
  Help,
  KeyOne,
  Left,
  Logout,
  Me,
  Peoples,
  Protect,
  Right,
  Rules,
} from "assets/Icon";
import {
  Button,
  Collapse,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  useTheme,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import { useSelector } from "react-redux";
import { useState } from "react";

const rules = {
  allRules: 5,
  exchange: 1,
  harvest: 3,
  loan: 4,
  investment: 6
};

const help = {
  questions: 15,
  exchange: 11,
  harvest: 13,
  loan: 14,
  investment: 16
};

function UserOptions({
  setOpenSecurity,
  setOpenChangePassword,
  setOpenSupport,
  setOpenProfile,
  setOpenActivities,
  setOpenLogout,
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isUserBlocked = useIsUserBlocked();

  const user = useSelector((state) => state.user?.user?.data);

  const [openListRules, setOpenListRules] = useState(false);
  const [openListHelp, setOpenListHelp] = useState(false);

  const handleOpenListRules = () => {
    setOpenListRules(!openListRules);
  };

  const handleOpenListHelp = () => {
    setOpenListHelp(!openListHelp);
  };

  const handleOpenSecurity = () => {
    setOpenSecurity(true);
    handleClose();
  };

  const handleOpenChangePassword = () => {
    setOpenChangePassword(true);
    handleClose();
  };

  const handleOpenSupport = () => {
    setOpenSupport(true);
    handleClose();
  };

  const handleOpenProfile = () => {
    setOpenProfile(true);
    handleClose();
  };

  const [open, setOpen] = useState(false);

  const handleClick = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ButtonStyle
        id="basic-ButtonStyle"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="text"
        color="text"
      >
        {open ? (
          <Right color={theme.palette.text.main} />
        ) : (
          <Left color={theme.palette.text.main} />
        )}
        {user?.userName || "-"}
      </ButtonStyle>

      <Drawer anchor="right" open={open} onClose={handleClose}>
        <ListStyle>
          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenProfile}>
              <ListItemIcon>
                <Me color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="پروفایل" />
            </ListItemButtonStyle>
          </ListItemStyle>

          <DividerStyle />

          {!isUserBlocked && (
            <>
              <ListItemStyle>
                <ListItemButtonStyle onClick={handleOpenSecurity}>
                  <ListItemIcon>
                    <Protect color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="امنیت" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle onClick={handleOpenChangePassword}>
                  <ListItemIcon>
                    <KeyOne color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="تغییر کلمه عبور" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle
                  onClick={() => {
                    navigate("/bank-accounts");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <BankCard color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="حساب‌های بانکی" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle
                  onClick={() => {
                    navigate("/referral");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <Peoples color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="معرفی به دوستان" />
                </ListItemButtonStyle>
              </ListItemStyle>

              <ListItemStyle>
                <ListItemButtonStyle
                  onClick={() => {
                    setOpenActivities(true);
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <Activity color={theme.palette.text.main} />
                  </ListItemIcon>
                  <ListItemText primary="فعالیت‌ها" />
                </ListItemButtonStyle>
              </ListItemStyle>
            </>
          )}

          <DividerStyle />

          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenSupport}>
              <ListItemIcon>
                <HeadsetOne color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="پشتیبانی" />
            </ListItemButtonStyle>
          </ListItemStyle>

          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenListRules}>
              <ListItemIcon>
                <Rules color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="قوانین" />
              {openListRules ? (
                <ion-icon name="chevron-up-outline" />
              ) : (
                <ion-icon name="chevron-down-outline" />
              )}
            </ListItemButtonStyle>
          </ListItemStyle>

          <Collapse in={openListRules} timeout="auto" unmountOnExit>
            <List component="div">
              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.allRules}`}
                onClick={handleClose}
              >
                <ListItemText primary="قوانین کلی سایت" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.exchange}`}
                onClick={handleClose}
              >
                <ListItemText primary="مبادله" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.harvest}`}
                onClick={handleClose}
              >
                <ListItemText primary="برداشت" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/rules/${rules.loan}`}
                onClick={handleClose}
              >
                <ListItemText primary="وام" />
              </ListItemButtonStyleItem>

              {
                user?.isHaveViewInvestment &&
                <ListItemButtonStyleItem
                  component={Link}
                  to={`/rules/${rules.investment}`}
                  onClick={handleClose}
                >
                  <ListItemText primary="سرمایه‌گذاری" />
                </ListItemButtonStyleItem>
              }
            </List>
          </Collapse>

          <ListItemStyle>
            <ListItemButtonStyle onClick={handleOpenListHelp}>
              <ListItemIcon>
                <Help color={theme.palette.text.main} />
              </ListItemIcon>
              <ListItemText primary="راهنما" />
              {openListHelp ? (
                <ion-icon name="chevron-up-outline" />
              ) : (
                <ion-icon name="chevron-down-outline" />
              )}
            </ListItemButtonStyle>
          </ListItemStyle>

          <Collapse in={openListHelp} timeout="auto" unmountOnExit>
            <List component="div">
              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.questions}`}
                onClick={handleClose}
              >
                <ListItemText primary="سوالات متدوال" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.exchange}`}
                onClick={handleClose}
              >
                <ListItemText primary="مبادله" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.harvest}`}
                onClick={handleClose}
              >
                <ListItemText primary="برداشت" />
              </ListItemButtonStyleItem>

              <ListItemButtonStyleItem
                component={Link}
                to={`/help/${help.loan}`}
                onClick={handleClose}
              >
                <ListItemText primary="وام" />
              </ListItemButtonStyleItem>

              {
                user?.isHaveViewInvestment &&
                <ListItemButtonStyleItem
                  component={Link}
                  to={`/help/${help.investment}`}
                  onClick={handleClose}
                >
                  <ListItemText primary="سرمایه‌گذاری" />
                </ListItemButtonStyleItem>
              }
            </List>
          </Collapse>

          <ListItemStyle>
            <ListItemButtonStyle
              onClick={() => {
                setOpenLogout(true);
                handleClose();
              }}
            >
              <ListItemIcon>
                <Logout color={theme.palette.secondary.main} />
              </ListItemIcon>
              <ListItemText primary="خروج" sx={{ color: "secondary.main" }} />
            </ListItemButtonStyle>
          </ListItemStyle>
        </ListStyle>
      </Drawer>
    </>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  svg: {
    marginRight: theme.spacing(1),
  },
}));

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),

  "&:hover": {
    background: theme.palette.background.blueReverseGradient,
  },
}));

const ListStyle = styled(List)(({ theme }) => ({
  minWidth: "300px",
  padding: 0,
}));

const ListItemButtonStyleItem = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 6, 0.5, 0),
  borderRadius: "5px",
  "&:hover": {
    background: theme.palette.background.blueReverseGradient,
  },
  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

const ListItemButtonStyle = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 1),
  borderRadius: "5px",

  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

const DividerStyle = styled(Divider)(({ theme }) => ({
  background: theme.palette.modules.divider,
}));

export default UserOptions;
